import { Ship, Clock, ShieldCheck, TrendingUp } from "lucide-react";

export function LaneCards({ data }) {
  if (!data || !Array.isArray(data.cards) || !data.cards.length) return null;
  return (
    <section className="border-b border-slate-200 bg-slate-50/70" data-testid="lane-cards">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12">
        {data.title && (
          <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">{data.title}</h2>
        )}
        {data.source && (
          <p className="font-num text-[10px] uppercase tracking-wider text-slate-400 mt-2">{data.source}</p>
        )}
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4 mt-8">
          {data.cards.map((c, i) => (
            <div
              key={i}
              data-testid={`lane-card-${i}`}
              className="bg-white border border-slate-200 rounded-xl p-5 transition-all duration-300 hover:shadow-lg hover:-translate-y-0.5"
            >
              <div className="flex items-start justify-between">
                <Ship className="w-4 h-4 text-slate-400" />
                <TrendingUp className="w-4 h-4 text-rose-400" />
              </div>
              <div className="font-num text-xs text-slate-500 mt-3">{c.origin}</div>
              <div className="font-display font-semibold text-slate-900 leading-tight">→ {c.dest}</div>
              <div className="font-display text-2xl font-bold tracking-tight text-slate-900 mt-3">{c.rate}</div>
              <div className="mt-4 space-y-2">
                <div className="flex items-center justify-between text-sm">
                  <span className="flex items-center gap-1.5 text-slate-500"><Clock className="w-3.5 h-3.5" /> Transit</span>
                  <span className="font-num font-semibold text-slate-800">{c.transit}</span>
                </div>
                <div className="flex items-center justify-between text-sm">
                  <span className="flex items-center gap-1.5 text-slate-500"><ShieldCheck className="w-3.5 h-3.5" /> Reliability</span>
                  <span className="font-num font-semibold text-slate-800">{c.reliability}%</span>
                </div>
                <div className="h-1.5 w-full rounded-full bg-slate-100 overflow-hidden">
                  <div className="h-full rounded-full bg-emerald-500" style={{ width: `${Math.max(0, Math.min(100, c.reliability))}%` }} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
